const colors = {
  primary: {
    main: "#dc9b28",
    dark: "#dc9b28de",
    accent: "#fcf7ee",
    error: "#ef4444",
    background: "#ffffff",
    foreground: "#000000",
  },
};

export default colors;
